<template>
  <div
    :class="['rank-avatar relative', rankingClass]"
    :style="{
      backgroundImage: `url('${avatarImg}')`
    }"
  >
    <img v-if="[1, 2, 3].includes(ranking)" class="crown absolute" :src="crownImg" />
  </div>
</template>
<script>
  /**
   * @description 观看端
   */
  import { getDefaultAvatar } from '@/app-shared/utils/ossImgConfig';
  import goldCrown from './img/gold.png';
  import silverCrown from './img/silver.png';
  import bronzeCrown from './img/bronze.png';

  const crownMap = [null, goldCrown, silverCrown, bronzeCrown];
  const rankingMap = ['', 'gold', 'silver', 'bronze'];

  export default {
    name: 'RankAvatar',
    props: {
      ranking: {
        type: Number,
        default() {
          return 2;
        }
      },
      src: {
        type: String,
        default() {
          return '';
        }
      }
    },
    computed: {
      avatarImg() {
        return this.src || getDefaultAvatar();
      },
      crownImg() {
        return crownMap[this.ranking] || '';
      },
      rankingClass() {
        return rankingMap[this.ranking] || '';
      }
    }
  };
</script>
<style lang="less" scoped>
  .rank-avatar {
    display: inline-block;
    width: 24px;
    height: 24px;
    border-radius: 50%;
    position: relative;
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    background-origin: initial;

    &.gold {
      border: 2px solid #ffcd5c;
    }

    &.silver {
      border: 2px solid #aeb7d4;
    }

    &.bronze {
      border: 2px solid #f4a37a;
    }

    .crown {
      width: 12px;
      height: 12px;
      top: -6px;
      right: -5px;
      position: absolute;
    }
  }
</style>
